<template lang="pug">
  .loader-target-default-place(ref="appLoaderDefaultPlace")
    .app-loader(ref="appLoader")
      transition(name="fade")
        .loader-overlay(
          v-if="$loader.isLoading && !$loader.options.hidden"
          :class="{ fullscreen: !$loader.target }"
        )
          sdo-loader
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';

const TARGET_CLASS = 'loader-target';
const ANIMATION_DURATION = 500;

export default {
  computed: {
    ...mapGetters({
      isAppLoading: 'isAppLoading',
    }),
  },
  watch: {
    '$loader.isLoading': function (val) {
      if (val) {
        if (this.$loader.target) {
          const [target] = document.getElementsByClassName(TARGET_CLASS);
          target.appendChild(this.$refs.appLoader);
        }
      } else {
        this.resetLoaderPlaceDebounce();
      }
    },
  },
  created() {
    this.resetLoaderPlaceDebounce = debounce(this.resetLoaderPlace, ANIMATION_DURATION);
  },
  methods: {
    resetLoaderPlace() {
      this.$refs.appLoaderDefaultPlace.appendChild(this.$refs.appLoader);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-loader {
  position: relative;
  height: 100%;

  .loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fullscreen {
    background: white;
    height: calc(100vh - 60px);
  }
}
</style>
